import { GameName } from 'constants/difficulty';
import { KingImages } from 'constants/tutorialKingImages';
import { SolitaireGame } from 'game/SolitaireGame';

const moves = [
    { cards: ['A1'], target: 'F', blockStockPile: true }, //
    { cards: ['21'], target: 'A1', blockStockPile: true },
    { cards: ['31'], target: '21', blockStockPile: true }, //
    { cards: ['A3'], target: 'F', blockStockPile: true }, //
    { cards: ['23'], target: 'A3', blockStockPile: true }, //
    { cards: ['J3'], target: 'Q0', blockStockPile: true }, //
    { cards: ['T1'], target: 'J3', blockStockPile: true }, //
    { cards: ['93'], target: 'T1', blockStockPile: true }, //
    { cards: ['81'], target: '93', blockStockPile: true }, //
    { cards: ['Q0', 'J3', 'T1', 'T1', '93', '81'], target: 'K3', blockStockPile: true }, //
    { cards: ['K1'], target: 'C', blockStockPile: true }, //
    {
        cards: ['33'],
        target: 'W',
    },
    {
        cards: [],
        target: '',
        freePlay: true,
        freePlayCondition: (game: SolitaireGame) => {
            return game.stockPile.length === 0;
        },
    },
    {
        cards: [],
        target: '',
        freePlay: true,
        freePlayCondition: (game: SolitaireGame) => {
            return !!game.stockPile.length;
        },
    }, //
    {
        cards: [],
        target: '',
        freePlay: true,
        freePlayCondition: () => {
            return false;
        },
    },
    // {cards: ['41'], target: 'W'}, //
    // {cards: ['A0', '20', '30', '50', '
];

const contentKeys = [
    { king: KingImages.LEFT_RED, contentKey: 'klondikeTutorialStep1' }, //
    { king: KingImages.LEFT_RED, contentKey: 'klondikeTutorialStep1' },
    { king: KingImages.LEFT_RED, contentKey: 'klondikeTutorialStep1' },
    { king: KingImages.RIGHT_BLACK_TWO, contentKey: 'klondikeTutorialStep2' },
    { king: KingImages.RIGHT_BLACK_TWO, contentKey: 'klondikeTutorialStep2' },
    { king: KingImages.HANDS_FORWARD, contentKey: 'klondikeTutorialStep3' },
    { king: KingImages.HANDS_FORWARD, contentKey: 'klondikeTutorialStep3' }, //
    { king: KingImages.HANDS_FORWARD, contentKey: 'klondikeTutorialStep3' }, //
    { king: KingImages.HANDS_FORWARD, contentKey: 'klondikeTutorialStep3' }, //
    { king: KingImages.LEFT_RED_RIGHT_BLACK, contentKey: 'klondikeTutorialStep4' }, //
    { king: KingImages.LEFT_EMPTY_RIGHT_RED, contentKey: 'klondikeTutorialStep5' },
    { king: KingImages.LEFT_BLUE, contentKey: 'klondikeTutorialStep6' },
    { king: KingImages.HANDS_DOWN, contentKey: 'klondikeTutorialStep7' },
    { king: KingImages.LEFT_BLUE_RESTART, contentKey: 'klondikeTutorialStep8' }, //
    { king: KingImages.HANDS_UP, contentKey: 'klondikeTutorialStep9' },
    { king: KingImages.HANDS_UP, contentKey: 'klondikeTutorialStep10' },
];
const step = {
    gameId: 'klondike_tutorial_step_1',
    columns: [
        [],
        [],
        [{ code: 'A1', visible: true }],
        [
            { code: '71', visible: false },
            { code: '21', visible: true },
        ],
        [
            { code: '43', visible: false },
            { code: 'A3', visible: false },
            { code: '31', visible: true },
        ],
        [
            { code: 'T3', visible: false },
            { code: 'K1', visible: false },
            { code: 'Q0', visible: false },
            { code: '23', visible: true },
        ],
        [
            { code: 'K3', visible: false },
            { code: '81', visible: false },
            { code: '93', visible: false },
            { code: 'T1', visible: false },
            { code: 'J3', visible: true },
        ],
    ],
    foundation: [
        [
            { code: 'A2', visible: true }, //
            { code: '22', visible: true }, //
            { code: '32', visible: true }, //
            { code: '42', visible: true }, //
            { code: '52', visible: true }, //
            { code: '62', visible: true }, //
            { code: '72', visible: true }, //
            { code: '82', visible: true }, //
            { code: '92', visible: true }, //
            { code: 'T2', visible: true }, //
            { code: 'J2', visible: true }, //
            { code: 'Q2', visible: true }, //
            { code: 'K2', visible: true }, //
        ],
        [
            { code: 'A0', visible: true }, //
            { code: '20', visible: true }, //
            { code: '30', visible: true }, //
            { code: '40', visible: true }, //
            { code: '50', visible: true }, //
            { code: '60', visible: true }, //
            { code: '70', visible: true }, //
            { code: '80', visible: true }, //
            { code: '90', visible: true }, //
            { code: 'T0', visible: true }, //
        ],
        [],
        [],
    ],
    name: GameName.KLONDIKE,
    movesCount: 0,
    moves: [],
    attempts: 0,
    score: 0,
    time: 0,
    wastePile: [],
    stockpile: [
        { code: '33', visible: false },
        { code: '41', visible: false },
        { code: 'J1', visible: false },
        { code: '63', visible: false },
        { code: '83', visible: false },
        { code: 'Q1', visible: false },
        { code: 'Q3', visible: false },
        { code: '51', visible: false },
        { code: 'J0', visible: false },
        { code: '91', visible: false },
        { code: '73', visible: false },
        { code: '61', visible: false },
        { code: 'K0', visible: false },
        { code: '53', visible: false },

        // { code: '41', visible: false },

        // { code: 'A0', visible: false },
        // { code: '20', visible: false },
        // { code: '30', visible: false },
        // { code: '50', visible: false },
        // { code: '60', visible: false },
        // { code: '70', visible: false },
        // { code: '80', visible: false },
        // { code: '90', visible: false },
        // { code: 'T0', visible: false },
    ],
};

export default { step, moves, contentKeys };
